import { formConfig } from "../formConfig";
import { SectionStatus } from "../schema";

function StatusIcon({ status }: { status: SectionStatus }) {
  if (status === "ok") return <span className="status-icon ok" title="Complete">✓</span>;
  if (status === "error") return <span className="status-icon error" title="Has errors">!</span>;
  return <span className="status-icon pending" title="Not complete" />;
}

export default function Tabs({
  active,
  onChange,
  statuses
}: {
  active: number;
  onChange: (i: number) => void;
  statuses?: SectionStatus[];
}) {
  return (
    <nav className="tabs">
      {formConfig.map((s, i) =>
        s.hidden ? null : (
          <button
            key={s.title}
            type="button"
            className={"tab " + (i === active ? "active" : "")}
            onClick={() => onChange(i)}
          >
            <StatusIcon status={statuses?.[i] ?? "pending"} />
            <span className="tab-title">{s.shortTitle}</span>
          </button>
        )
      )}
    </nav>
  );
}
